import * as React from 'react';
import * as _ from 'underscore';

import NumberField from '../../../_common/platform/tsx/NumberField';
import SelectField from '../../../_common/platform/tsx/SelectField';

require('../sass-main/pdc-widget-gis.sass');
declare var require: any;

export class GISPositionField extends React.Component<
    {
        value?: any;
        allowNull?: boolean;
        title?: string;

        options?: {
            title?: string;
            allowNull?: boolean; //LL
        };
        disabled?: boolean;
        readOnly?: boolean;

        onChange?(value: any);
    },
    {
        value: {
            center: string;
            zoom: number;
            latitude: number;
            longitude: number;
        };
        scheme: string;
    }
> {
    private static DEFAULT_SCHEME = 'dark';

    constructor(props) {
        super(props);
        var value = this.props.value;
        this.state = {
            value: value,
            scheme: GISPositionField.DEFAULT_SCHEME
        };
    }
    componentDidMount() {
        this.setScheme();
    }

    setScheme = () => {
        /* var textElement = React.findDOMNode<HTMLInputElement>(this.refs["text"]);
         var styles = getComputedStyle(textElement);
         if (styles == null) {
             return;
         }

         var isLight;
         try {
             isLight = Color(styles.color).light();
         } catch (e) {
             isLight = false;
         }

         var scheme = GISPositionField.DEFAULT_SCHEME = isLight ? 'light' : 'dark';
 */
        //if (this.state.scheme !== scheme)
        {
            const state = this.state;
            //  state.scheme = scheme;
            this.setState(state);
        }
    };

    componentWillReceiveProps(newProps) {
        const newValue = newProps.value;
        if (newValue !== this.props.value) {
            this.setState({ value: newValue });
        }
    }

    normalize(value) {
        value.center = value.center ? value.center : 'CenterToContent';
        value.zoom = value.zoom ? value.zoom : 5;
        value.latitude = value.latitude ? value.latitude : 41.89051;
        value.longitude = value.longitude ? value.longitude : 12.49424;
    }

    onChangeZoom = (val) => {
        var value = {
            center: _.clone(this.state.value.center),
            zoom: val,
            latitude: _.clone(this.state.value.latitude),
            longitude: _.clone(this.state.value.longitude)
        };
        this.normalize(value);
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    onChangeLatitude = (val) => {
        var value = {
            center: _.clone(this.state.value.center),
            zoom: _.clone(this.state.value.zoom),
            latitude: val,
            longitude: _.clone(this.state.value.longitude)
        };
        this.normalize(value);
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    onChangeLongitude = (val) => {
        var value = {
            center: _.clone(this.state.value.center),
            zoom: _.clone(this.state.value.zoom),
            latitude: _.clone(this.state.value.latitude),
            longitude: val
        };
        this.normalize(value);
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    handleCenterChange = (val) => {
        var value = {
            center: val,
            zoom: _.clone(this.state.value.zoom),
            latitude: _.clone(this.state.value.latitude),
            longitude: _.clone(this.state.value.longitude)
        };
        this.normalize(value);
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    render() {
        var className = 'visible margin';
        if (this.state.value.center == 'CenterToContent' || this.state.value.center == 'CenterToMyLocation') {
            className = 'invisible';
        }
        var types = {
            values: ['CenterToContent', 'CenterToMyLocation', 'CenterManually'],
            display: ['Center To Content', 'Center To My Location', 'Center Manually']
        };
        var tzValue = this.state.value.center;
        return (
            <div>
                <b>Initial Position</b>
                <div className="pdc-widget-gis-config">
                    <div className="margin">
                        <SelectField value={tzValue} options={types} onChange={this.handleCenterChange} />
                    </div>
                    <div className={className}>
                        <b>Zoom</b>
                        <NumberField value={this.state.value.zoom} integer={false} onChange={this.onChangeZoom} />
                    </div>
                    <div className={className}>
                        <b>Latitude</b>
                        <NumberField
                            value={this.state.value.latitude}
                            integer={false}
                            onChange={this.onChangeLatitude}
                        />
                    </div>
                    <div className={className}>
                        <b>Longitude</b>
                        <NumberField
                            value={this.state.value.longitude}
                            integer={false}
                            onChange={this.onChangeLongitude}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
